import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TicketProvider } from "@/context/TicketContext";
import { TechProvider } from "@/context/TechContext";
import { SubscriberProvider } from "@/context/SubscriberContext";
import Dashboard from "@/pages/Dashboard";
import DeviceDetailPage from "@/pages/DeviceDetailPage";
import ActiveTicketsPage from "@/pages/ActiveTicketsPage";
import AllActiveTicketsPage from "@/pages/AllActiveTicketsPage";
import HistoryPage from "@/pages/HistoryPage";
import DispatchedTicketsPage from "@/pages/DispatchedTicketsPage";
import TechPortalPage from "@/pages/TechPortalPage";
import SettingsPage from "@/pages/SettingsPage";
import FieldTechsPage from "@/pages/FieldTechsPage";

function App() {
  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.remove();
  }, []);

  return (
    <TechProvider>
      <TicketProvider>
        <SubscriberProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/subscriber/:subscriberId/devices" element={<DeviceDetailPage />} />
              <Route path="/subscriber/:subscriberId/tickets" element={<ActiveTicketsPage />} />
              <Route path="/active-tickets" element={<AllActiveTicketsPage />} />
              <Route path="/subscriber/:subscriberId/history" element={<HistoryPage />} />
              <Route path="/dispatched" element={<DispatchedTicketsPage />} />
              <Route path="/tech/:ticketId" element={<TechPortalPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/settings/field-techs" element={<FieldTechsPage />} />
            </Routes>
          </BrowserRouter>
        </SubscriberProvider>
      </TicketProvider>
    </TechProvider>
  );
}

export default App;
